import { useState } from "react";
import Layout from "./Layout.js";
import {
  save_update_point,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  handleSuccessShow,
} from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";

const AddPoints = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [pointForm, setPointForm] = useState({
    type: "",
    operationalHoursFrom: "",
    operationalHoursTo: "",
    pointName: "",
    pointAddress: "",
    latitude: "",
    longitude: "",
    description: "",
    key_phases: "",
    status: "0",
    max_capacity: "0",
  });

  const handleSubmitPoint = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let fd = new FormData();
    fd.append("type", pointForm.type);
    fd.append("start_time", pointForm.operationalHoursFrom);
    fd.append("end_time", pointForm.operationalHoursTo);
    fd.append("lat", pointForm.latitude);
    fd.append("long", pointForm.longitude);
    fd.append("point_name", pointForm.pointName);
    fd.append("point_address", pointForm.pointAddress);
    fd.append("description", pointForm.description);
    fd.append("key_phases", pointForm.key_phases);
    fd.append("status", pointForm.status);
    if (pointForm.type === "Parking") {
      fd.append("max_capacity", pointForm.max_capacity);
    }

    await server_post_data(save_update_point, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          handleSuccessShow(Response.data.message);
          setIsLoading(false);
          setPointForm({
            type: "",
            operationalHoursFrom: "",
            operationalHoursTo: "",
            pointName: "",
            pointAddress: "",
            latitude: "",
            longitude: "",
            description: "",
            key_phases: "",
            status: "Active",
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="page">
          <h2 className="page-title">Add New Points</h2>
          <div className="tabs-container">
            <div className="tab-content">
              <div className="forms-grid">
                {/* Point Management Form */}
                <div className="form-card point-form-card">
                  <h3 className="form-title">Add Point</h3>
                  <form onSubmit={handleSubmitPoint} className="point-form">
                    <div className="form-row">
                      <div className="form-group">
                        <label className="label">Point Name:</label>
                        <input
                          type="text"
                          className="input"
                          placeholder="Enter point name"
                          value={pointForm.pointName}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              pointName: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label className="label">Type:</label>
                        <select
                          className="select"
                          value={pointForm.type}
                          onChange={(e) =>
                            setPointForm({ ...pointForm, type: e.target.value })
                          }
                          required
                        >
                          <option value="">Select Type</option>
                          <option value="Ghat">Ghat</option>
                          <option value="Temple">Temple</option>
                          <option value="Parking">Parking</option>
                          <option value="Medical">Medical Center</option>
                          <option value="Food Court">Food Court</option>
                          <option value="Information Center">
                            Information Center
                          </option>
                          <option value="Security Post">Security Post</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="label">Status:</label>
                        <select
                          className="select"
                          value={pointForm.status}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              status: e.target.value,
                            })
                          }
                        >
                          <option value="0">Active</option>
                          <option value="1">Inactive</option>
                          <option value="2">Under Maintenance</option>
                        </select>
                      </div>
                      {pointForm.type === "Parking" && (
                        <div className="form-group">
                          <label className="label">Max Capacity:</label>
                          <input
                            type="text"
                            className="input"
                            value={pointForm.max_capacity}
                            onChange={(e) =>
                              setPointForm({
                                ...pointForm,
                                max_capacity: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      )}
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label className="label">Operational Hours From:</label>
                        <input
                          type="time"
                          className="input"
                          value={pointForm.operationalHoursFrom}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              operationalHoursFrom: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label className="label">Operational Hours To:</label>
                        <input
                          type="time"
                          className="input"
                          value={pointForm.operationalHoursTo}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              operationalHoursTo: e.target.value,
                            })
                          }
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label className="label">Latitude:</label>
                        <input
                          type="number"
                          step="any"
                          className="input"
                          placeholder="e.g., 25.3176"
                          value={pointForm.latitude}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              latitude: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label className="label">Longitude:</label>
                        <input
                          type="number"
                          step="any"
                          className="input"
                          placeholder="e.g., 82.9739"
                          value={pointForm.longitude}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              longitude: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label className="label">Point Address:</label>
                        <textarea
                          className="textarea"
                          placeholder="Enter complete address"
                          value={pointForm.pointAddress}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              pointAddress: e.target.value,
                            })
                          }
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label className="label">Description:</label>
                        <textarea
                          className="textarea"
                          placeholder="Enter detailed description of the point "
                          value={pointForm.description}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              description: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="label">Key Phases:</label>
                        <textarea
                          className="textarea"
                          placeholder="Enter Key Phases of the point Example - Near River, Next to Big Tree,"
                          value={pointForm.key_phases}
                          onChange={(e) =>
                            setPointForm({
                              ...pointForm,
                              key_phases: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="submit-button point-submit-button"
                    >
                      Add Point Information
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default AddPoints;
